var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h2",
    { staticClass: "d-inline-block", staticStyle: { position: "relative" } },
    [
      _vm.$router.currentRoute.name == "mediaCallPage"
        ? _c(
            "div",
            {
              staticClass: "media-call-icon",
              class: !_vm.userAbilities.createMediaCall
                ? "pointer-default"
                : "",
              on: {
                click: function($event) {
                  _vm.userAbilities.createMediaCall ? _vm.createMediaCall() : ""
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("@/csmworkflow/img/media-call.svg") }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]
          )
        : _c("div", { staticClass: "media-call-icon" }, [
            _c("img", {
              attrs: {
                src: require("@/csmworkflow/img/" +
                  _vm.deliverableTemplateIcon +
                  ".svg")
              }
            })
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "deliverableTemplate-buttons-fade" } },
        [
          _vm.showAllAddButton &&
          _vm.hasMultipleDeliverableTemplate &&
          _vm.userAbilities.createMediaCall
            ? _c(
                "div",
                { staticClass: "all-deliverableTemplate-buttons" },
                _vm._l(_vm.newDeliverableTemplates, function(type, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "media-call-icon",
                      on: {
                        click: function($event) {
                          return _vm.createDeliverableTemplate(type)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/csmworkflow/img/" +
                            type.typeIcon +
                            ".svg")
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "add-media-call-icon" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/csmworkflow/img/add-icon.svg")
                          }
                        })
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v("\n\n    " + _vm._s(_vm.deliverableTemplateTitle) + "\n    "),
      _vm.showDeliverableTemplateCount
        ? _c("span", { staticClass: "text-muted below-title" }, [
            _vm._v(
              _vm._s(_vm.deliverableTemplateCount) + " DeliverableTemplate"
            ),
            _vm.deliverableTemplateCount !== 1
              ? _c("span", [_vm._v("s")])
              : _vm._e(),
            _vm.$router.currentRoute.name != "socialMedia" &&
            _vm.$router.currentRoute.name != "socialMediaGrouped" &&
            _vm.$router.currentRoute.name != "socialMediaSchedule"
              ? _c("span", [
                  _vm._v(", " + _vm._s(_vm.totalOutletCount) + " Calls")
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeliverableTemplateCountMyWeek
        ? _c("span", { staticClass: "text-muted" }, [
            _vm._v("\n        (\n        "),
            _vm.deliverableTemplateCount["overdue"] > 0
              ? _c(
                  "a",
                  {
                    style: { backgroundColor: _vm.getBgColor("overdue") },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("overdue")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["overdue"]) +
                        " overdue"
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    style: {
                      backgroundColor: _vm.getBgColor("overdue"),
                      pointerEvents: "none",
                      texDecoration: "none",
                      color: "var(--wf-secondary-tertiary-mix80)"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("overdue")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["overdue"]) +
                        " overdue"
                    )
                  ]
                ),
            _vm._v(",\n        "),
            _vm.deliverableTemplateCount["today"] > 0
              ? _c(
                  "a",
                  {
                    style: { backgroundColor: _vm.getBgColor("today") },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("today")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["today"]) + " today"
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    style: {
                      backgroundColor: _vm.getBgColor("today"),
                      pointerEvents: "none",
                      texDecoration: "none",
                      color: "var(--wf-secondary-tertiary-mix80)"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("today")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["today"]) + " today"
                    )
                  ]
                ),
            _vm._v(",\n        "),
            _vm.deliverableTemplateCount["thisWeek"] > 0
              ? _c(
                  "a",
                  {
                    style: { backgroundColor: _vm.getBgColor("thisWeek") },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("thisWeek")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["thisWeek"]) +
                        " this week"
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    style: {
                      backgroundColor: _vm.getBgColor("thisWeek"),
                      pointerEvents: "none",
                      texDecoration: "none",
                      color: "var(--wf-secondary-tertiary-mix80)"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("thisWeek")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["thisWeek"]) +
                        " this week"
                    )
                  ]
                ),
            _vm._v(",\n        "),
            _vm.deliverableTemplateCount["nextWeek"] > 0
              ? _c(
                  "a",
                  {
                    style: { backgroundColor: _vm.getBgColor("nextWeek") },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("nextWeek")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["nextWeek"]) +
                        " next week"
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    style: {
                      backgroundColor: _vm.getBgColor("nextWeek"),
                      pointerEvents: "none",
                      texDecoration: "none",
                      color: "var(--wf-secondary-tertiary-mix80)"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("nextWeek")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["nextWeek"]) +
                        " next week"
                    )
                  ]
                ),
            _vm._v(",\n        "),
            _vm.deliverableTemplateCount["upcoming"] > 0
              ? _c(
                  "a",
                  {
                    style: { backgroundColor: _vm.getBgColor("upcoming") },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("upcoming")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["upcoming"]) +
                        " upcoming"
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    style: {
                      backgroundColor: _vm.getBgColor("upcoming"),
                      pointerEvents: "none",
                      texDecoration: "none",
                      color: "var(--wf-secondary-tertiary-mix80)"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("upcoming")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["upcoming"]) +
                        " upcoming"
                    )
                  ]
                ),
            _vm._v(",\n        "),
            _vm.deliverableTemplateCount["noDeadline"] > 0
              ? _c(
                  "a",
                  {
                    style: { backgroundColor: _vm.getBgColor("noDeadline") },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("noDeadline")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["noDeadline"]) +
                        " no deadline"
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    style: {
                      backgroundColor: _vm.getBgColor("noDeadline"),
                      pointerEvents: "none",
                      texDecoration: "none",
                      color: "var(--wf-secondary-tertiary-mix80)"
                    },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        return _vm.overdueClick("noDeadline")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.deliverableTemplateCount["noDeadline"]) +
                        " no deadline"
                    )
                  ]
                ),
            _vm._v("\n      )\n    ")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "add-media-call-icon" }, [
      _c("img", { attrs: { src: require("@/csmworkflow/img/add-icon.svg") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }